import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiErrorMessage } from "@/api/axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, Loader2 } from "lucide-react";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      const formData = new URLSearchParams();
      formData.append("email", email.trim());
      const res = await api.post("/api/auth/forgot-password", formData, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (res.data.success) {
        setSuccess("Письмо отправлено. Проверьте почту.");
      } else {
        const err = res.data.error || "Ошибка отправки";
        if (err === "Email не подтвержден") {
          setError("Для использования этой функции необходимо подтвердить email в личном кабинете.");
        } else {
          setError(err);
        }
      }
    } catch (err: unknown) {
      const errorMsg = apiErrorMessage(err, "Ошибка отправки");
      if (errorMsg === "Email не подтвержден") {
        setError("Для использования этой функции необходимо подтвердить email в личном кабинете.");
      } else {
        setError(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md border-slate-700 bg-slate-900/80 backdrop-blur">
        <CardHeader className="space-y-1 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Shield className="h-6 w-6 text-primary" />
          </div>
          <CardTitle className="text-2xl text-white">Восстановление пароля</CardTitle>
          <p className="text-sm text-slate-400">Введите email для сброса пароля</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="rounded-md bg-destructive/15 p-3 text-sm text-destructive">
                {error}
              </div>
            )}
            {success && (
              <div className="rounded-md bg-emerald-500/15 p-3 text-sm text-emerald-400">
                {success}
              </div>
            )}
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium text-slate-300">Email</label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                className="border-slate-700 bg-slate-800 text-white placeholder:text-slate-500"
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Отправить
            </Button>
            <div className="text-center text-sm text-slate-400">
              <Link to="/login" className="text-primary hover:underline">
                Вернуться к входу
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
